import axios from "axios";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import MasterLayoutFrontend from "./layout/frontend/MasterLayoutFrontend";
import AddminPrivateRoute from "./routes/admin/AdminPrivateRoute";
import DeleteAccount from "./component/frontend/DeleteAccount";

// API BASE URL
axios.defaults.baseURL = "https://api.dirtmap.net";
//  axios.defaults.baseURL = "http://127.0.0.1:8000";

axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

function App() {
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    const videoShown = localStorage.getItem("videoShown");

    if (!videoShown) {
      const timer = setTimeout(() => {
        setShowVideoPopup(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const closeVideo = () => {
    setShowVideoPopup(false);
    localStorage.setItem("videoShown", "true");
  };

  return (
    <div className="App">
      {/* VIDEO POPUP */}
      {showVideoPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.85)",
            zIndex: 999999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: "800px",
              position: "relative",
            }}
          >
            {/* CLOSE BUTTON */}
            <button
              onClick={closeVideo}
              style={{
                position: "absolute",
                top: "-45px",
                right: "0",
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                border: "none",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: "bold",
                zIndex: 10,
              }}
            >
              ✕
            </button>

            {/* LOADER */}
            {!videoReady && !videoError && (
              <div
                style={{
                  color: "#fff",
                  textAlign: "center",
                  padding: "30px",
                  fontSize: "18px",
                }}
              >
                Loading video...
              </div>
            )}

            {/* ERROR */}
            {videoError && (
              <div
                style={{
                  color: "#fff",
                  textAlign: "center",
                  padding: "30px",
                  fontSize: "18px",
                }}
              >
                Unable to load video
              </div>
            )}

            {/* VIDEO */}
            <video
              src="/landscapeDirt20-june.mp4"
              autoPlay={true}
              muted={true}
              playsInline={true}
              controls={true}
              preload="metadata"
              width="100%"
              style={{
                display: videoReady ? "block" : "none",
                borderRadius: "10px",
              }}
              onCanPlay={() => setVideoReady(true)}
              onEnded={closeVideo}
              onError={() => {
                console.log("Video failed to load");
                setVideoError(true);
              }}
            />
          </div>
        </div>
      )}

      <Router>
        <Switch>
          {/* DELETE ACCOUNT PAGE */}
          <Route
            exact
            path="/delete-account"
            component={DeleteAccount}
          />

          {/* ADMIN */}
          <AddminPrivateRoute path="/admin" name="Admin" />

          {/* FRONTEND */}
          <Route
            path="/"
            name="Home"
            render={(props) => (
              <MasterLayoutFrontend {...props} />
            )}
          />
        </Switch>
      </Router>
    </div>
  );
}

export default App;